<template>
  <div
    id="app"
    style="width: 100%; margin: 0; padding: 0"
    :class="{
      needScale: ![
        '/accountform',
        '/appform',
        '/studentrequest',
        '/form/aeo',
        '/form/success',
        '/schoolclubprofile'
      ].includes($route.path),
    }"
  >
    <!-- Only render navigation if layout is not 'blank' -->
    <template v-if="$route.meta.layout !== 'blank'">
      <header v-if="canShowHeader" class="head">
        <img :src="require('./assets/image/eclub-logo-3-white.png')" class="logo" style="height: 30px;" @click="navigateToOfficialHome" />
        <span style="color: white; font-size: 12px; margin-left: 8px;">by</span>
        <img :src="require('./assets/image/header-logo.png')" class="logo-eae" style="height: 24px; margin-left: 6px;" @click="navigateToOfficialHome" />
        <span style="font-size: 20px; font-weight: bold; margin-right: auto; margin-left: 15px;">

          <span style="color: #f87f6a; font-size: 14px; background: white; padding: 2px 8px; border-radius: 6px;margin-left: 10px;">BETA Version</span>
        </span>
        <div>
          <template v-if="user_id && user_id.length == 24">
            <span style="margin-right: 15px">{{
              (userType?.toUpperCase() || '') + ": " +
              userName +
              (accountName || schoolName ? " @ " + (accountName || schoolName) : "") +
              "&nbsp [ " +
              accountCountry +
              " ]"
            }}</span>
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link" style="cursor: pointer; margin-right: 24px; color: white;">
                <i class="el-icon-setting"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="contentOrders">
                  <i class="el-icon-document"></i> Content Orders
                </el-dropdown-item>
                <el-dropdown-item command="logout">
                  <i class="el-icon-switch-button"></i> Logout
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template v-else>
            <el-button 
              type="text" 
              style="color: #fa6a51; margin-right: 24px; font-size: 14px; background: white; padding: 2px 8px; border-radius: 6px;"
              @click="$router.push('/login')"
            >
              LOGIN
            </el-button>
          </template>
        </div>
      </header>
    </template>
    
    <router-view @login-success="handleLoginSuccess"></router-view>
  </div>
</template>
<script>
import {
  getUserId,
  getUserName,
  getUserType,
  getUserAccountCountry,
  getSchoolName,
  getAccountName,
  removeUserId,
  removeUserName,
  removeUserType,
  removeUserAccountCountry,
  removeAccountId,
  removeSchoolName,
  removeAccountName
} from "@/utils/store";

export default {
  name: "app",
  data() {
    return {
      user_id: getUserId(),
      userName: getUserName(),
      userType: getUserType(),
      accountCountry: getUserAccountCountry(),
      schoolName: getSchoolName(),
      accountName: getAccountName()
    };
  },
  computed: {
    canShowHeader() {
      return !["/login", "/adviser-registration"].includes(this.$route.path) && !this.$route.path.startsWith('/official');
    },

  },
  mounted() {
    // Initialize user data
    this.updateUserData();
    this.$root.$on('updateUserName', (userName) => {
      // Update the component's user name data
      this.userName = userName; // Assuming you have a userName data property
    });
  },
  created() {
    this.$root.$on('user-logged-in', async (forceUpdate) => {
      await this.handleUserLogin(forceUpdate)
    })
  },
  beforeDestroy() {
    this.$root.$off('user-logged-in');
    this.$root.$off('updateUserName');
  },
  methods: {
    updateUserData() {
      this.user_id = getUserId();
      this.userName = getUserName();
      this.userType = getUserType();
      this.accountCountry = getUserAccountCountry();
      this.schoolName = getSchoolName();
      this.accountName = getAccountName();
    },
    handleLoginSuccess(userData) {
      // Update local state
      this.user_id = userData.user_id;
      this.userName = userData.user_name;
      this.userType = userData.user_type;
      this.accountCountry = userData.account_country;
      this.schoolName = userData.school_name;
      this.accountName = userData.account_name;
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.logout();
      } else if (command === 'contentOrders') {
        this.$router.push('contentOrders');
      }
    },
    logout() {
      this.$confirm(
        "Are you sure you want to log out?",
        "Logout Confirmation",
        {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          removeUserId();
          removeUserName();
          removeUserAccountCountry();
          removeUserType();
          removeAccountId();
          removeSchoolName();
          removeAccountName();
          sessionStorage.removeItem("currentIndex");
          // Update local state
          this.updateUserData();
          this.$router.replace("/login");
        })
        .catch(() => {});
    },
    async handleUserLogin(forceUpdate = false) {
      // Refresh user info from cookies/storage
      this.updateUserData();
      
      if (forceUpdate) {
        // Force component re-render
        this.$forceUpdate()
      }
    },
    navigateToOfficialHome() {
      this.$router.push('/official/home');
    }
  },
};
</script>

<style>
.el-popover {
  background-color: #fff4f3 !important;
  border: none;
  word-break: keep-all !important;
  word-wrap: break-word !important;
  text-align: left !important;
}
</style>

<style lang="scss" scoped>
.needScale {
  width: 100vw;
}

.head {
  height: 50px;
  position: relative;
  font-size: 12px;
  background-color: #fa6a51 !important;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logo {
    
    height: 40px;
    margin-left: 24px;
    cursor: pointer;
  }
}
::v-deep .el-table .el-table__cell {
  padding-left: 12px;
  padding-right: 12px;
}

::v-deep .el-main {
  margin: 0px;
  padding: 0px;
  background: #f8f8f8;
}

.el-container {
  margin: 0px;
  padding: 0px;
  // min-width: 1920px;
}

* {
  padding: 0;
  margin: 0;
}

#app {
  padding: 0;
  margin: 0;
  color: #606266;
}

.app-nav::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #eaeaea;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  background: #fff;
}

.el-menu {
  background: none;
}

.mobileConfirm {
  width: 80% !important;

  .el-message-box__container {
    display: flex;

    .el-message-box__status {
      position: relative;
      flex-shrink: 0;
      transform: none;
    }

    .el-message-box__message {
      padding-left: 10px;
    }
  }
}

::v-deep .el-button--primary {
  background-color: #fa6a51;
  border-color: #fa6a51;
  &:hover, &:active, &:focus {
    background-color: #f87f6a;
    border-color: #f87f6a;
  }
}
</style>
